export default __webpack_public_path__ + "static/center-kr-d9570658777ad1ecf9407d84e7a0baa4.webp";